import { motion } from "framer-motion";
import { TIMELINE } from "@/constants/site";
import { useTimeline } from "@/context/ImagesContext";

const EASE = [0.22, 1, 0.36, 1];

const Timeline = () => {
  const milestones = useTimeline() || TIMELINE;

  return (
    <section id="timeline" data-testid="heritage-timeline-section" className="py-24 sm:py-32 lg:py-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="lg:col-span-4"
        >
          <p className="eyebrow mb-6">Heritage</p>
          <h2 className="font-display font-normal text-espresso text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
            A journey measured in
            <span className="italic text-forest"> generations.</span>
          </h2>
        </motion.div>

        <div className="lg:col-span-8">
          <ol className="relative border-l border-amber-brand/25 ml-2 md:ml-4 space-y-14">
            {milestones.map((m, i) => (
              <motion.li
                key={`${m.year}-${i}`}
                data-testid={`timeline-milestone-${m.year}`}
                initial={{ opacity: 0, x: 32 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.85, delay: i * 0.08, ease: EASE }}
                className="relative pl-8 md:pl-12"
              >
                <span
                  className="absolute -left-[7px] top-2 w-3.5 h-3.5 rounded-full bg-gold border-4 border-cream"
                  aria-hidden="true"
                />
                <p className="font-mono-alt text-sm tracking-[0.3em] text-amber-brand">{m.year}</p>
                <h3 className="mt-2 font-display text-2xl sm:text-3xl font-medium text-espresso">{m.title}</h3>
                <p className="mt-2 text-muted-brand leading-relaxed max-w-lg">{m.text}</p>
              </motion.li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default Timeline;
